import React from "react";
import Formsy from "formsy-react";
import Select from "react-select";
import hasPermission from "../../utils/functions/hasPermission";
import assign from "object-assign";

let ValidatedInput = React.createClass({
    mixins: [Formsy.Mixin],
    propTypes: {
        name: React.PropTypes.string,
        type: React.PropTypes.string,
        inputClassName: React.PropTypes.string,
        placeholder: React.PropTypes.string,
        label: React.PropTypes.string
    },
    getInitialState(){
        return {
            focused: false
        };
    },
    changeSelectValue(value, optionObject) {
        this.setValue(value);
        this.props.onChange(value);
    },
    changeDumbSelectValue(event) {
        let target = event.currentTarget;
        let value = target.value;

        this.setValue(value);
        this.props.onChange(this.props.name, value);
    },
    changeInputValue(e) {
        this.setValue(e.currentTarget.value);
        this.props.onChange(e.currentTarget.value);
    },
    changeCheckboxValue() {
        let newValue = !this.getValue();

        this.setValue(newValue);
        this.props.onChange(newValue);
    },
    getInput(type){
        switch (type) {
            case "checkbox":
                return (
                    <label className="eo-input-checkbox-label">
                        <input className={["eo-input-checkbox", this.props.inputClassName].join(" ")}
                               type="checkbox"
                               name={this.props.name}
                               onChange={this.changeCheckboxValue}
                               value={this.getValue()}
                               checked={this.getValue()}
                               autoComplete={this.props.autoComplete === false ? "off" : "on"}
                        />
                        { this.props.checkboxLabel }
                    </label>
                );
            case "dumbSelect":
                let opts = assign({}, this.props.selectProps).options;

                return (
                    <div className={[this.props.inputClassName, "eo-select eo-dumb-select", (this.props.selectProps.clearable === false ? "no-clear" : "")].join(" ")}>
                        <select placeholder={this.props.placeholder}
                                name={this.props.name}
                                onChange={this.changeDumbSelectValue}
                                value={this.getValue()}
                                id={this.props.id}
                                autoComplete={this.props.autoComplete === false ? "off" : "on"}>
                            <option>State</option>
                            { opts.map((opt, i) => <option key={i} value={opt.value}>{opt.label}</option>) }
                        </select>
                    </div>
                );
            case "select":
                let selectProps = assign({}, this.props.selectProps);

                selectProps.options = selectProps.options.filter(option => {
                    const granted = this.props.currentAdmin && this.props.currentAdmin.role ? this.props.currentAdmin.role.permissions : [],
                        allowed = hasPermission(granted, option.permissions);

                    return !option.permissions || allowed;
                });

                return (
                    <Select placeholder={this.props.placeholder}
                            className={[this.props.inputClassName, "eo-select", (this.props.selectProps.clearable === false ? "no-clear" : "")].join(" ")}
                            name={this.props.name}
                            onChange={this.changeSelectValue}
                            value={this.getValue()}
                            id={this.props.id}
                            autoComplete={this.props.autoComplete === false ? "off" : "on"}
                        {...selectProps}/>
                );
            default:
                return (
                    <input placeholder={this.props.placeholder}
                           className={["eo-input", this.props.inputClassName].join(" ")}
                           type={type || "text"}
                           name={this.props.name}
                           id={this.props.id}
                           autoComplete={this.props.autoComplete === false ? "off" : "on"}
                           onChange={this.changeInputValue}
                           value={this.getValue()}/>
                );
        }
    },
    render() {
        let errorMessage = this.getErrorMessage();

        return (
            <div
                className={["eo-validated-input", this.props.className, (this.showError() ? "error" : null), (this.showRequired() ? "required" : null)].join(" ")}>
                { this.props.label ?
                    <label className="eo-input-label" htmlFor={this.props.name}>{this.props.label}</label> : null }
                {this.getInput(this.props.type)}
                <span className="eo-validation-error">{this.showRequired() ? "Required" : errorMessage}</span>
            </div>
        );
    }
});

export default ValidatedInput;


/** WEBPACK FOOTER **
 ** ./app/utils/components/ValidatedInput.js
 **/